import { render, staticRenderFns } from "./configEdit.vue?vue&type=template&id=74ceddb3&scoped=true&"
import script from "./configEdit.vue?vue&type=script&lang=js&"
export * from "./configEdit.vue?vue&type=script&lang=js&"
import style0 from "./configEdit.vue?vue&type=style&index=0&id=74ceddb3&lang=less&scoped=true&"
import style1 from "./configEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ceddb3",
  null
  
)

export default component.exports